import type { DeliveryStatus, DeliveryType } from "@types_def/models/delivery.types";

export function formatRoute(route?: DeliveryType | DeliveryStatus) {
  return route?.toLowerCase().replaceAll("_", "-");
}
